import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const map = useMapContext()
    map.useNodeChange(map.root, ['data'])
    const {mapTypeCode} = map.data
    const {rmType} = map.root.data

    if (
        '_RULEMRM_MAP' !== mapTypeCode ||
        'DOMAIN_KNOWLEDGE' !== rmType
    ) {
        return null
    }

    const onClick = () => {
        const {pkid: rmId, prjId, rmCode, rmName, rmNo, sVer} = map.root.data

        openWindow(
            '/Ai',

            {
                bizMap: {rmCode, rmId, rmName, rmNo},
                prjId,
                scene: 'GENERATE_DK',
                sVer,
                title: `知识模块: ${rmName}`,
            }
        )
    }

    return {
        label: '领域知识',
        onClick,
        ...props,
    }
}
